import { connect } from 'react-redux';
import { languages } from 'components/forecast-demo/constants';

// Selectors
import {
  getSelectedYear,
  getMonths,
  getSelectedMonth,
  getDays,
  getSelectedDay,
  getHours,
  getSelectedHour,
  getComparingYears,
  getComparingMonths,
  getSelectedComparingYear,
  getSelectedComparingMonth,
  getComparingDays,
  getSelectedComparingDay,
  getComparingHours,
  getSelectedComparingHour,
  getSelectedLanguageF,
} from 'components/forecast-demo/selectors';

// Actions
import {
  setYear,
  // setComparingYears,
  setMonth,
  setComparingMonth,
  setDay,
  setComparingDay,
  setHour,
  setComparingHour,
  setLanguageF,
  startComparing,
  stopComparing,
} from 'components/forecast-demo/actions';

// Components
import BottomBar from './component';
// import { generateKeyPairSync } from "crypto";
// import { get } from "http";
import { getYears } from 'components/emissions-demo/selectors';

const mapStateToProps = state => ({
  months: getMonths(state),
  hours: getHours(state),
  days: getDays(state),
  years: getYears(state),
  selectedYear: getSelectedYear(state),
  selectedMonth: getSelectedMonth(state),
  selectedHour: getSelectedHour(state),
  selectedDay: getSelectedDay(state),
  selectedDate: state.forecastDemo.state.date,
  timezone: state.forecastDemo.state.timezone,
  comparingYears: getComparingYears(state),
  comparingMonths: getComparingMonths(state),
  comparingHours: getComparingHours(state),
  comparingDays: getComparingDays(state),
  selectedComparingYear: getSelectedComparingYear(state),
  selectedComparingMonth: getSelectedComparingMonth(state),
  selectedComparingHour: getSelectedComparingHour(state),
  selectedComparingDay: getSelectedComparingDay(state),
  selectedComparingDate: state.forecastDemo.state.comparingDate,
  comparing: !!getSelectedComparingMonth(state),
  languages,
  selectedLanguageF: getSelectedLanguageF(state),
  selectedTimezone: state.forecastDemo.state.dateTimezone,
});

const mapDispatchToProps = dispatch => ({
  setYear: year => dispatch(setYear(year)),
  setMonth: month => dispatch(setMonth(month)),
  setComparingMonth: month => dispatch(setComparingMonth(month)),
  setDay: day => dispatch(setDay(day)),
  setComparingDay: day => dispatch(setComparingDay(day)),
  setHour: hour => dispatch(setHour(hour)),
  setComparingHour: hour => dispatch(setComparingHour(hour)),
  setLanguageF: language => dispatch(setLanguageF(language)),
  toggleComparing: comparing => dispatch(comparing ? startComparing() : stopComparing()),
});

export default connect(mapStateToProps, mapDispatchToProps)(BottomBar);



// WEBPACK FOOTER //
// ./src/components/forecast-demo/components/bottom-bar/index.js